import '../../css/mk-brand.css';
import BattleSchool from '../../media/home-chef3.png';
import heroOGChefMale from '../../media/home-chef2.png';
import {useEffect} from "react";

function Panel() {
  useEffect(() => {}, );
  return (
      <div id="mk-battle-school" className="m-2">
        <div className="container bg-zinc-800 pt-4 px-4 pb-4 rounded-lg max-w-4xl">
          <div className="flex flex-row">
            <div className="mx-auto hidden md:block">
              <div className="">
                <img src={BattleSchool} className="max-h-68" />
              </div>
              <div className="">
                <img src={heroOGChefMale} className="max-h-68" />
              </div>
            </div>
            <div className="max-w-xl mx-auto mb-10">
              <h2 className="flex">
                <h2 className="mb-2 text-4xl sm:text-6xl font-extrabold leading-none">
                  mK
                </h2>
                <h2 className="mb-2 text-4xl sm:text-6xl font-extrabold leading-none text-brand">
                  Battle
                </h2>
                &nbsp;
                <h2 className="mb-2 text-4xl sm:text-6xl font-extrabold leading-none text-brand-text">
                  School
                </h2>
              </h2>
              <p className="mb-6 text-white md:text-2xl">
                A simplified version of the mKBattle Kitchen that introduces the chefs to mKBattle rules, methods, and strategies. mKBattle School teaches the chefs the concept of creating a great Dish.
              </p>
              <div className="flex flex-col w-full overflow-hidden bg-zinc-200 rounded-lg border border-black border-2 text-black">
                <div className="flex items-center p-10 bg-brand ">
                  <span className="text-3xl text-brand-text">Creating the perfect Dish</span>
                </div>
                <div className="px-4">
                  <p className="p-4 md:text-2xl">
                    What is a Dish? A dish is the fundamental component of each mKBattle. To make a Dish a chef must do the following:
                  </p>
                  <ol className="list-decimal px-4 md:px-16 md:text-2xl">
                    <li className="p-4"><b>Select a Recipe</b> upon which to base the Dish. Normally this Recipe would include the Mystery Ingredient as all Dishes MUST incorporate the Mystery Ingredient.</li>
                    <li className="p-4"><b>Select the Ingredients</b> to be included. In some cases you may choose to substitute some of the Ingredients for others (especially if you are missing some of the ingredients). Try to substitute like items (one grain for another for example). Special consideration is given when using the Mystery Ingredient as a substitute for suitable Ingredients.</li>
                    <li className="p-4"><b>Select the Utensils.</b> Just like Ingredients if you don't have some of the required Utensils you may choose a substitute. Again try to choose a like item (e.g.: another sharp thing instead of a knife).</li>
                    <li className="p-4"><b>Submit the Dish</b></li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
}

export default Panel;